// export const API_BASE_URL = 'https://localhost:7197';
export const API_BASE_URL = 'https://hotel-verify.azurewebsites.net';